import { render, staticRenderFns } from "./addVendorDetails.vue?vue&type=template&id=f4135670"
import script from "./addVendorDetails.vue?vue&type=script&lang=js"
export * from "./addVendorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports